import Wrapper from "../../../layout/Wrapper";
import ApproveLifeInsuranceComponent from "../../../screens/approveds/life-insurance/approve";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Approved Life Insurance",
	description: "",
};

export default function ApproveLifeInsurance() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ApproveLifeInsuranceComponent />
		</Wrapper>
	);
}